import { Object } from "core-js";

export default Object.freeze({
    EasipikCustomer: 'EasipikCustomer',
    NonEasipikCustomer: 'NonEasipikCustomer'
});